<template>
    <div>
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: "WebAppEvents"
    }
</script>

<style lang="scss" scoped>

</style>